import posthog from 'posthog-js';

let initialized = false;

export function init(): void {
  if (initialized) return;
  const key = process.env.REACT_APP_POSTHOG_API_KEY;
  if (!key) return;

  try {
    posthog.init(key, {
      api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com',
      person_profiles: 'identified_only',
      capture_pageview: false,
      // Sin `ip: false`: PostHog deriva pais/ciudad del IP y despues lo descarta.
      // Con la opcion prendida no habia geo para ningun usuario web, asi que no
      // se podia decidir donde hacer distribucion. Ver spec 2026-09-21 §4.7.
    });
    initialized = true;
  } catch {
    // degrade silently
  }
}

/**
 * Identifica al usuario y sincroniza sus person properties.
 *
 * El distinct_id es SIEMPRE el user.id de la base, igual que en mobile y en el
 * server, para que una persona sea una sola persona en PostHog.
 *
 * `setOnce` es para valores que marcan la primera vez que algo paso y no se
 * deben pisar (fecha de signup, primer partido). Ver spec 2026-09-21 §6.
 */
export function identify(
  userId: string,
  properties?: Record<string, any>,
  setOnce?: Record<string, any>
): void {
  if (!initialized) return;
  try { posthog.identify(userId, properties, setOnce); } catch {}
}

export function reset(): void {
  if (!initialized) return;
  try { posthog.reset(); } catch {}
}

export function track(event: string, properties: Record<string, any> = {}): void {
  if (!initialized) return;
  try { posthog.capture(event, properties); } catch {}
}
